import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

// Последний рубеж — если что-то в рендере бросит необработанное исключение (например,
// данные с сервера разошлись с типом, как уже бывало с GpsPosition.technicianName),
// без этого весь SPA падает в белый экран без единого объяснения на экране
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Необработанная ошибка интерфейса', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary-screen">
          <h2>Что-то пошло не так</h2>
          <p className="muted">
            Произошла непредвиденная ошибка интерфейса. Попробуйте обновить страницу — если
            проблема повторится, сообщите об этом.
          </p>
          <button onClick={() => window.location.reload()}>Обновить страницу</button>
        </div>
      );
    }
    return this.props.children;
  }
}
